// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.product-configurator {
  margin-bottom: 60px;
}

h2 {
  margin: 15px 0;
}

h3 {
  font-size: 2.4rem;
  font-family: "Omnes-ATT-W02";
}

.label-block {
  display: block;
  margin-bottom: 10px;
}

.lisencecontainer {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  margin: 20px 0 30px;
  padding: 20px;
}
.lisencecontainer .qty-block {
  margin-left: -15px;
}
.lisencecontainer .qty-error {
  margin-bottom: 0;
  margin-left: 15px;
}
.lisencecontainer .discount-copy {
  margin-top: 20px;
}

.volume-discount {
  margin-bottom: 8px;
}

.singeline {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  margin: 20px 0;
  padding: 20px;
}
.singeline .price-detail {
  display: block;
  text-align: center;
}
.singeline .price-detail .price-value {
  font-size: 24px;
  margin-bottom: 5px;
}
.singeline .price-detail .price-value + p {
  margin-bottom: 0;
}
.singeline .service-charge {
  margin-top: 20px;
}
.singeline .service-charge .small-left {
  text-align: center;
}
.singeline .service-charge .price-value {
  font-size: 1.6rem;
}
.singeline.totalcontainer {
  background: hsl(150, 100%, 24%);
  border: 1px solid hsl(150, 100%, 24%);
  color: hsl(0, 0%, 95%);
}
.singeline.selected-row {
  border: 2px solid hsl(150, 100%, 24%);
}
.singeline hr {
  margin: 20px 80px 0 45px;
}

.separatorgrey {
  border-right: 1px solid #d2d2d2;
}

.separatorwhite {
  border-right: 1px solid white;
}

.btn-update {
  padding: 8px 18px 7px;
}

.service-charge p {
  margin-bottom: 0;
}

.err-label {
  color: hsl(0, 66%, 49%);
}

.skudesc {
  margin-left: 8.33%;
}

.cart-hr {
  margin: 30px 0;
}

.valign-children-middle {
  margin-top: 10px;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media (max-width: 1024px) {
  .product-configurator {
    margin-bottom: 0;
    padding-bottom: 10px;
  }
  h1 {
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
  .sku-text-sm {
    margin-bottom: 20px;
  }
  .singeline .price-detail {
    display: inline-block;
    margin-top: 20px;
  }
  .singeline .price-detail .price-value {
    text-align: left;
  }
  .singeline .price-detail .price-value + p {
    margin-bottom: 10px;
  }
  .singeline .service-charge .small-left {
    text-align: left;
  }
  .singeline hr {
    margin: 20px 0 0;
  }
  .singeline.totalcontainer h3 {
    margin-bottom: 15px;
  }
  .radio-margin,
  .skudesc {
    margin-left: 16.66% !important;
  }
  button .btn {
    margin: 0;
  }
  .btn {
    text-align: center;
  }
  .btn-cart {
    width: 100%;
  }
  .btn-update {
    width: 100%;
  }
  .btn-link {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .cart-hr {
    margin: 20px 0;
  }
  .separatorgrey,
  .separatorwhite {
    border-right: 0;
  }
  .total-border {
    border: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/product-configurator/product-configurator.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA/IA;EACE,mBAAA;AAiJF;;AA9IA;EACE,cAAA;AAiJF;;AA9IA;EACE,iBAAA;EACA,4BAAA;AAiJF;;AA/IA;EACE,cAAA;EACA,mBAAA;AAkJF;;AAhJA;EFgBI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEdF,yBAAA;EACA,mBAAA;EACA,aAAA;AAuJF;AArJE;EACE,kBAAA;AAuJJ;AApJE;EACE,gBAAA;EACA,iBAAA;AAsJJ;AAnJE;EACG,gBAAA;AAqJL;;AAjJA;EACI,kBAAA;AAoJJ;;AAjJA;EFRI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEUF,yBAAA;EACA,cAAA;EACA,aAAA;AAwJF;AAtJE;EACE,cAAA;EACA,kBAAA;AAwJJ;AAtJI;EACE,eAAA;EACA,kBAAA;AAwJN;AAtJM;EACE,gBAAA;AAwJR;AAnJE;EACE,gBAAA;AAqJJ;AAnJI;EACE,kBAAA;AAqJN;AAlJI;EACE,iBAAA;AAoJN;AAhJE;EACE,+BAAA;EACA,qCAAA;EACA,sBAAA;AAkJJ;AA/IE;EACE,qCAAA;AAiJJ;AA9IE;EACE,wBAAA;AAgJJ;;AA5IA;EACE,+BAAA;AA+IF;;AA5IA;EACE,6BAAA;AA+IF;;AA5IA;EACE,qBAAA;AA+IF;;AA3IE;EACE,gBAAA;AA8IJ;;AA1IA;EACE,uBAAA;AA6IF;;AA1IA;EACE,kBAAA;AA6IF;;AA1IA;EACE,cAAA;AA6IF;;AA1IA;EACE,gBAAA;AA6IF;;AA1IA;;EAEE,wBAAA;EACA,SAAA;AA6IF;;AFrPI;EE4GF;IACE,gBAAA;IACA,oBAAA;EA6IF;EA1IA;IACE,eAAA;EA4IF;EAzIA;IACE,eAAA;EA2IF;EAxIA;IACE,eAAA;EA0IF;EAvIA;IACE,mBAAA;EAyIF;EArIE;IACE,qBAAA;IACA,gBAAA;EAuIJ;EArII;IACE,gBAAA;EAuIN;EArIM;IACE,mBAAA;EAuIR;EAjII;IACE,gBAAA;EAmIN;EA/HE;IACE,gBAAA;EAiIJ;EA7HI;IACE,mBAAA;EA+HN;EA1HA;;IAEE,8BAAA;EA4HF;EAxHE;IACE,SAAA;EA0HJ;EAtHA;IACE,kBAAA;EAwHF;EArHA;IACE,WAAA;EAuHF;EApHA;IACE,WAAA;EAsHF;EAnHA;IACE,gBAAA;IACA,mBAAA;EAqHF;EAlHA;IACE,cAAA;EAoHF;EAjHA;;IAEE,eAAA;EAmHF;EAhHA;IACE,SAAA;EAkHF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","// Product configurator page component styling\n\n@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.product-configurator {\n  margin-bottom: 60px;\n}\n\nh2 {\n  margin: 15px 0;\n}\n\nh3 {\n  font-size: 2.4rem;\n  font-family: 'Omnes-ATT-W02';\n}\n.label-block{\n  display: block;\n  margin-bottom: 10px;\n}\n.lisencecontainer {\n  @include vendor-prefix('border-radius', 8px);\n  border: 1px solid color(default, dark);\n  margin: 20px 0 30px;\n  padding: 20px;\n\n  .qty-block {\n    margin-left: -15px;\n  }\n\n  .qty-error {\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n\n  .discount-copy {\n     margin-top: 20px;\n  }\n}\n\n.volume-discount {\n    margin-bottom:8px;\n  }\n\n.singeline {\n  @include vendor-prefix('border-radius', 8px);\n  border: 1px solid color(default, dark);\n  margin: 20px 0;\n  padding: 20px;\n\n  .price-detail {\n    display: block;\n    text-align: center;\n\n    .price-value {\n      font-size: 24px;\n      margin-bottom: 5px;\n\n      & + p {\n        margin-bottom: 0;\n      }\n    }\n }\n\n  .service-charge {\n    margin-top: 20px;\n\n    .small-left {\n      text-align: center;\n    }\n\n    .price-value {\n      font-size: 1.6rem;\n    }\n  }\n\n  &.totalcontainer {\n    background: color(success, base);\n    border: 1px solid color(success, base);\n    color: color(default, base);\n  }\n\n  &.selected-row {\n    border: 2px solid color(success, base);\n  }\n\n  hr {\n    margin: 20px 80px 0 45px;\n  }\n}\n\n.separatorgrey {\n  border-right: 1px solid color(default, dark);\n}\n\n.separatorwhite {\n  border-right: 1px solid color(default, light);\n}\n\n.btn-update {\n  padding: 8px 18px 7px;\n}\n\n.service-charge {\n  p {\n    margin-bottom: 0;\n  }\n}\n\n.err-label {\n  color: color(danger, base);\n}\n\n.skudesc {\n  margin-left: 8.33%;\n}\n\n.cart-hr {\n  margin: 30px 0;\n}\n\n.valign-children-middle {\n  margin-top: 10px;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n@include respond-to(small) {\n  .product-configurator {\n    margin-bottom: 0;\n    padding-bottom: 10px;\n  }\n\n  h1 {\n    font-size: 20px;\n  }\n\n  h2 {\n    font-size: 18px;\n  }\n\n  h3 {\n    font-size: 16px;\n  }\n\n  .sku-text-sm {\n    margin-bottom: 20px;\n  }\n\n  .singeline {\n    .price-detail {\n      display: inline-block;\n      margin-top: 20px;\n\n      .price-value {\n        text-align: left;\n\n        & + p {\n          margin-bottom: 10px;\n        }\n      }\n    }\n\n    .service-charge {\n      .small-left {\n        text-align: left;\n   }\n }\n\n    hr {\n      margin: 20px 0 0;\n   }\n\n    &.totalcontainer {\n      h3 {\n        margin-bottom: 15px;\n     }\n   }\n }\n\n  .radio-margin,\n  .skudesc {\n    margin-left: 16.66% !important;\n  }\n\n  button {\n    .btn {\n      margin: 0;\n    }\n  }\n\n  .btn {\n    text-align: center;\n  }\n\n  .btn-cart {\n    width: 100%;\n  }\n\n  .btn-update {\n    width: 100%;\n  }\n\n  .btn-link {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .cart-hr {\n    margin: 20px 0;\n  }\n\n  .separatorgrey,\n  .separatorwhite {\n    border-right: 0;\n  }\n\n  .total-border {\n    border: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
